import React from 'react'
import RewardTab from './RewardTab';
import RewardToken from './RewardToken';

const Reward = () => {
    return (
        <>
            <div>
                <div className="_reward_nft_hero">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_reward_nft_hero_wrap">
                                    <img src="assets/img/allblocksimg.png" alt="chobi" className="_reward_nft_hero_img" />
                                    <h1 className="_reward_nft_hero_title">Introducing</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="_reward_nft_stake_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <h5 className="_reward_nft_stake_subtitle">Stake AB Token, earn up to</h5>
                                <h2 className="_reward_nft_stake_title">53.28% apy</h2>
                                <span className="_reward_nft_stake_title_line" />
                                <div className="_reward_nft_stake_title_btn_wrap">
                                    <a href="#0" className="_reward_nft_stake_title_btn1">buy book</a>
                                    <a href="#0" className="_reward_nft_stake_title_btn2">add to wallet <span className="_reward_nft_stake_title_btn2_ic"><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24">
                                        <path stroke="#292D32" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6 12h12m-6 6V6" />
                                    </svg>
                                    </span></a>
                                </div>
                            </div>
                        </div>
                        <RewardTab/>
                    </div>
                </div>
                <RewardToken/>
            </div>
        </>
    )
}

export default Reward;